import type { OutroScreen } from '../../../types/survey';
import { SurveyMarkdown } from './SurveyMarkdown';

// Phase 6B D4 — the thank-you screen after a successful submit.
export function OutroView({ outro }: { outro: OutroScreen }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm">
      <div className="mb-3 text-3xl text-kyck-600">✓</div>
      <h1 className="text-xl font-semibold text-slate-900">{outro.title || 'Thanks for your response'}</h1>
      <div className="mt-3 text-left">
        <SurveyMarkdown markdown={outro.bodyMarkdown} />
      </div>
      {outro.ctaLabel && outro.ctaUrl && (
        <a
          href={outro.ctaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="mt-6 inline-flex items-center justify-center rounded-md bg-kyck-600 px-4 py-2 text-sm font-medium text-white hover:bg-kyck-700"
        >
          {outro.ctaLabel}
        </a>
      )}
    </div>
  );
}
